import loadable from '@loadable/component';

import './NewOffer.css';

export default loadable(() => {
  return import('./NewOffer.jsx');
});
